// Path: ./src/app/pages/CreateStorePage/styled.ts
import styled from "styled-components";
import { Typography, Box } from "@mui/material";

export const gridItemSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
};

export const GridProps = {
  item: true,
  xs: 12,
  md: 12,
  style: { width: "100%" },
  sx: gridItemSx,
};

export const SectionHeader = styled(Typography)`
  font-weight: 600;
  font-size: 1.2rem;
  color: #333;
  margin: 16px 0 8px 0;
  display: flex;
  align-items: center;

  &:before {
    content: "";
    width: 4px;
    height: 24px;
    background: #f58220;
    margin-right: 12px;
    border-radius: 2px;
  }
`;

export const SectionBox = styled(Box)`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
`;
